/**
 * The Support and Feedback glyph (an "i" in a circle), shared by the sidebar
 * rail entry and SupportFallbackButton so the two read as one control.
 * Sized by its container's CSS; inherits `currentColor`.
 */
export function SupportIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="16" x2="12" y2="12" />
      <circle cx="12" cy="8" r="0.5" fill="currentColor" stroke="none" />
    </svg>
  );
}
